import { SaveOperation } from '@infuse/api/common';
import { UiNotificationType } from '@infuse/ui/domain';
import { useNotify } from '@infuse/ui/services';
import { getAxiosErrorMessage } from '@infuse/utils';
import { useMutation, useQueryClient } from '@tanstack/vue-query';
import { useI18n } from 'vue-i18n';

export const useGenericForgotPasswordUser = ({
  apiFn,
  forcedParentId
}: {
  apiFn: SaveOperation<void, unknown>;
  forcedParentId?: string;
}) => {
  useQueryClient();
  const notify = useNotify();
  const { t } = useI18n({ useScope: 'global' });

  const mutation = useMutation<unknown, unknown, { parentId?: string; id: string }>({
    mutationFn: async ({ parentId, id }) => {
      if (forcedParentId) {
        parentId = forcedParentId;
      }

      try {
        await apiFn(parentId ? { id: parentId, userId: id } : { userId: id }, undefined);
        notify({
          title: t('iam.users.header.forgot_password'),
          message: t('iam.users.notify.forgot_password_success')
        });
      } catch (e) {
        notify({
          type: UiNotificationType.ERROR,
          title: t('iam.users.header.forgot_password'),
          message: getAxiosErrorMessage(e, t('iam.users.notify.forgot_password_failed'))
        });
        throw e;
      }
    }
  });

  return {
    ...mutation
  };
};
